<template>
<div class='bodyer recharge-log'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-jilu float-left'></i>兑换记录
                </div>
                <div class='col-md-10'>
                    <a class='yi-btn white-o sm pull-right'
                        href='/#/recharge/pay'>充值记录</a>
                </div>
            </div>
        </div>
    </div>
    <div class='banner'>
        <img src='/static/image/recharge/banner.jpg'>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='title'>游戏兑换</div>
            <div class='content row'>
                <div class='col-md-3'>
                    <ul class='list-group nav'>
                        <li class='list-group-item active'
                            @click='getList()'>
                            <img class='icon' src='/static/image/recharge/icon-ali.png'>
                            游戏兑换记录
                        </li>
                    </ul>
                </div>
                <div class='col-md-9 list-log'>
                    <div class='box-search row'>
                        <div class='col-md-9 box-where'>
                            <table>
                                <tr>
                                    <td>请选择查询时间:</td>
                                    <td>
                                        <div  class='form-inline'>
                                            <input type='text' class='form-control form-inline input-date' v-model='where.date_start' data-model='where.date_start'>
                                            至 
                                            <input type='text' class='form-control form-inline input-date' v-model='where.date_end' data-model='where.date_end'>
                                        </div>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>验证码:</td>
                                    <td>
                                        <div class='form-inline'>
                                            <input type='text' class='form-control'>
                                            <img src='/static/image/verify.png' class='verify-code'>
                                        </div>
                                    </td>
                                </tr> -->
                            </table>
                        </div>
                        <div class='col-md-3 box-btn'>
                            <button class='yi-btn orange' @click='getList(1)'>查询</button>
                        </div>
                    </div>

                    <table class='yi-table list'>
                        <tr><th>序号</th>
                            <th>日期</th>
                            <th>金额</th>
                            <th>游戏</th>
                            <th>状态</th>
                        </tr><tr v-for='item in list'>
                            <td>{{item.id}}</td>
                            <td>{{item.created_at}}</td>
                            <td>{{item.amount}}</td>
                            <td>{{item.game.name}}</td>
                            <td>{{item.status_text}}</td>
                        </tr>
                    </table>
                    <me-page :max='page_info.max' :now='page_info.now'
                        @go-page='getList'></me-page>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Storage from '@/common/Storage'
import Notify from '@/common/Notify'
import Request from '@/common/Request'
import Common from '@/common/Common'
import Pagination from '@/components/util/Pagination'
export default {
    data : function(){
        return {
            'list' : [],
            'where_trade' : {
                'channel' : 'wx'
            },
            'where' : {
                'date_start' : '',
                'date_end' : ''
            },
            'page_info':{
                'max': 1,
                'now': 1
            }
        }
    },
    props : ['user'],
    methods : {
        //列表获取
        getList : function(page){
            var page = page || 1
            var url = Request.createApi('/app/redeem-game/list?page='+page)
            var param = {
                'where' : this.where,
                'where_trade' : this.where_trade
            }

            Request.post(url, param, res => {
                this.list = res.list
                this.page_info = res.page_info
            })

            this.list = []
        },
    },
    mounted : function(){
        //日期插件声明
        $('.input-date').datetimepicker({
            language:  'zh-CN',
            format: 'yyyy-mm-dd',
            weekStart: 1,
            todayBtn:  1,
            autoclose: 1,
            todayHighlight: 1,
            startView: 2,
            forceParse: 0,
            showMeridian: 1,
            minView : 2
        });
        $('.input-date').change(function(){
            var command = 'self.'+ $(this).data('model') + ' = "'+ $(this).val() + '"';
            console.log(command)
            eval(command);
        })

        var self = this
    },
    created : function(){
        if(!this.user){
            Common.toUrl('/login')
            return true
        }

        this.getList()
        
        window.scrollTo(0, 0)
    },
    components: {
        'me-page': Pagination
    }
}
</script>


// WEBPACK FOOTER //
// src/components/recharge/RedeemLog.vue